import React, { useCallback, useEffect, useState } from 'react';

import { Grid } from "@mui/material";

import {
    BreadCrumbs,
    Table,
    Column,
    PageTitleWithToolTip,
    DataGrid,
} from "../../Common";
import { postRequestHeaders } from '../../../utils';

import Routes from '../../../routes';
import {
    dataGridContainerProps,
    text_commonCellProps,
    select_commonCellProps,
} from '../../Common/DataGrid/utils';
import { BadgeWithLinkedText, StyledCellLink } from '../../Common/DataGrid/CellComponents';
import { getDateRangeFilterOperator, getRangeFilterOperator } from '../../Common/DataGrid/FilterComponents';
import { TranslateW } from '../../../Utils/Languages/Translate';

const dateRangeFilterOperator = getDateRangeFilterOperator({});
const rangeFilterOperator = getRangeFilterOperator({});

const MaterialTranfers = () => {

    const [tableFilters, setTableFilters] = useState([]);

    const filters = useCallback(async () => {
        const response = await fetch(Routes.MaterialTransfers.TableFilter(0), {
            method: "POST",
            headers: {...postRequestHeaders},
        });

        const filters = await response.json();
        setTableFilters(filters);
    }, []);

    const columns = [
        {
          field: 'workOrderNumber',
          headerName: 'Customer Work Order #',
          ...text_commonCellProps,
          renderCell: ({ row: { workOrderNumber, serviceEventCoolingApplianceId, workOrderStatusName } }) => (
            <BadgeWithLinkedText
              statusProperty={workOrderStatusName}
              text={workOrderNumber}
              to={{
                pathname: `/ServiceEvent/${serviceEventCoolingApplianceId}`,
                state: {
                    from: window.location.pathname
                }
              }}
              
            />
          )
        },
        {
          field: 'transferDate',
          headerName: 'Transfer Date',
          type: 'datetime',
          valueGetter: (date) => date,
          filterOperators: dateRangeFilterOperator,
          flex: 1
        },
        {
          field: 'materialTypeName',
          headerName: 'Material Type',
          ...select_commonCellProps,
        },
        {
          field: 'transferWeight',
          headerName: 'Transfer Weight',
          filterOperators: rangeFilterOperator,
          flex: 1,
        },
        {
          field: 'transferType',
          headerName: 'Transfer Type',
          ...select_commonCellProps,
        },
        {
          field: 'fromAssetName',
          headerName: 'From Asset',
          ...select_commonCellProps,
          renderCell: ({ row: { fromAssetName, fromAssetId } }) => {
            return fromAssetId ? (
              <StyledCellLink
                path={`/Inventory/${fromAssetId}`}
                text={fromAssetName}
                from={window.location.pathname}
              />
            ) : (
              fromAssetName
            );
          }
        },
        {
          field: 'toAssetName',
          headerName: 'To Asset',
          ...select_commonCellProps,
          renderCell: ({ row: { toAssetName, toAssetId } }) => {
            return toAssetId ? (
              <StyledCellLink
                path={`/Inventory/${toAssetId}`}
                text={toAssetName}
                from={window.location.pathname}
              />
            ) : (
              toAssetName
            );
          }
            
        },
        {
          field: 'serviceProvider',
          headerName: 'Service Provider',
          initiallyVisible: false,
          ...select_commonCellProps
        },
        {
          field: 'fromLocationName',
          headerName: 'From Location',
          ...select_commonCellProps,
          initiallyVisible: false,
          filterable: false,
          renderCell: ({ row: { fromLocationName, fromLocationId } }) => (
            <StyledCellLink
              path={`/Location/${fromLocationId}`}
              text={fromLocationName}
              from={window.location.pathname}
            />
          )
        },
        {
          field: 'toLocationName',
          headerName: 'To Location',
          ...select_commonCellProps,
          initiallyVisible: false,
          filterable: false,
          renderCell: ({ row: { toLocationName, toLocationId } }) => (
            <StyledCellLink
              path={`/Location/${toLocationId}`}
              text={toLocationName}
              from={window.location.pathname}
            />
          )
        },
        {
          field: 'id',
          headerName: 'Transfer ID',
          ...text_commonCellProps,
          initiallyVisible: false,
          filterable: false
        },
        {
          field: 'locations',
          headerName: 'Location',
          ...select_commonCellProps,
          initiallyVisible: false,
          hiddenFromTogglable: true, 
        },
        {
          field: 'locationsNameCode',
          headerName: 'Location Name and Code',
          ...text_commonCellProps,
          initiallyVisible: false,
          hiddenFromTogglable: true, 
        },
      ];
      
    useEffect(() => {
        filters();
    }, [filters]);

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Material Transfers" },
                ]}
            />

            <Grid container direction="row" alignItems="center">
                <Grid item xs={6} md={6} lg={6}>
                    <PageTitleWithToolTip
                        pageTitle={"Material Transfers"}
                        toolTipText={"Search material transfers made to or from an asset tracked in trakref. Transfers include: Recover transfers (Service Recovery), Install transfers (Service Install) and Cylinder to Cylinder transfers"}
                    />
                </Grid>
                <Grid item { ...dataGridContainerProps }>
                    <DataGrid
                        printLandscape
                        url={Routes.MaterialTransfers.Table()}
                        exportButtonURL={Routes.MaterialTransfers.MaterialTranfersTableExport()}
                        noResultText="Oops...It is empty here..."
                        noResultText2="Create a new material transfer or change your search criteria."
                        exportButtonAlt={TranslateW('ExportMaterialTable')}
                        filterOptions={tableFilters}
                        tableId={"material-transfer-table"}
                        columns={columns}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default MaterialTranfers;
